import { render, staticRenderFns } from "./UiImagePreview.vue?vue&type=template&id=203acf5b&scoped=true"
import script from "./UiImagePreview.vue?vue&type=script&lang=js"
export * from "./UiImagePreview.vue?vue&type=script&lang=js"
import style0 from "./UiImagePreview.vue?vue&type=style&index=0&id=203acf5b&prod&lang=scss&scoped=true"
import style1 from "./UiImagePreview.vue?vue&type=style&index=1&id=203acf5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203acf5b",
  null
  
)

export default component.exports